import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./SupportTransfer.css";
import { Col, Form, Row } from "react-bootstrap";
import ModalSave from "../../ModalSave";
import { SaveButton, CancelButton } from "../../Button";
import { getData, postData } from "../../../../utils/api";
import Select from "react-select";
import ModalComplaintSave from "../../ModalComplaintSave";

const SupportTransfer = ({ show, onHide, getAllData, id }) => {
  const [errors, setErrors] = useState({});

  const [from, setFrom] = useState("");
  const [engineer, setEngineer] = useState(null);
  const [serviceEngineer, setServiceEngineer] = useState([]);

  const [productSelections, setProductSelections] = useState([]);

  const [assignLoading, setAssignLoading] = useState(false);
  const [schedule_time, setScheduleTime] = useState("");
  const [completion_date, setCompletionDate] = useState("");

  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const validateForm = () => {
    const newErrors = {};

    if (!engineer) {
      newErrors.engineer = "Please select a service engineer";
    }

    if (!completion_date) {
      newErrors.engineer = "Please select a Completion date";
    }

    if (!schedule_time) {
      newErrors.engineer = "Please select a Schedule Time";
    }

    if (!from) {
      newErrors.from = "Please select a schedule date";
    } else {
      const selectedDate = new Date(from);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (selectedDate < today) {
        newErrors.from = "Schedule date cannot be in the past";
      }
    }

    if (!completion_date) {
      newErrors.from = "Please select a Completion date";
    } else {
      const selectedDate = new Date(completion_date);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (selectedDate < today) {
        newErrors.from = "Completion date cannot be in the past";
      }
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const GetAllServiceEngineer = async () => {
    const response = await getData("/masters/all-service-engineers");

    if (response.success) {
      const options = response.data.map((data) => ({
        value: data.value,
        label: data.label,
      }));
      setServiceEngineer(options);
    }
  };

  useEffect(() => {
    GetAllServiceEngineer();
  }, []);

  const handleAssignEngineer = async () => {
    if (!validateForm()) return;

    try {
      setAssignLoading(true);

      const response = await postData(
        `/complaint-management/preventive-maintainance/transfer-engineer/${id}`,
        {
          user_id: engineer.value,
          schedule_from: from,
          schedule_time: schedule_time,
          completion_date: completion_date,
        },
      );

      if (response.success) {
        setShowModal({
          code: response.code,
          message: response.message,
        });

        setTimeout(() => {
          getAllData();
          onHide();
          setEngineer(null);
          setFrom("");
          setErrors({});
          setShowModal({ code: 0, message: "" });
          window.location.reload();
        }, 1500);
      } else {
        setTimeout(() => setShowModal({ code: 0, message: "" }), 1500);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setAssignLoading(false);
    }
  };

  return (
    <Modal
      className="common_modal Extend_Service_Modal"
      centered
      show={show}
      onHide={onHide}
      size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Transfer To Another Engineer</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Row>
          <Col xl={4} lg={5} md={6} sm={12}>
            <div className="main_div mb-3">
              <Form.Label>Service Engineer</Form.Label>
              <Select
                className={
                  errors.engineer
                    ? "input-mandatory is-invalid"
                    : "input-mandatory"
                }
                value={engineer}
                onChange={(val) => {
                  setEngineer(val);
                  setErrors((prev) => ({ ...prev, engineer: "" }));
                }}
                options={serviceEngineer}
              />
              {errors.engineer && (
                <small className="text-danger">{errors.engineer}</small>
              )}
            </div>
          </Col>
          <Col xl={4} lg={5} md={6} sm={12}>
            <Form.Label>Schedule Date</Form.Label>
            <input
              type="date"
              className={`form-control ${errors.from ? "is-invalid" : ""}`}
              value={from}
              min={new Date().toISOString().split("T")[0]} // ✅ prevents past date selection
              onChange={(e) => {
                setFrom(e.target.value);
                setErrors((prev) => ({ ...prev, from: "" }));
              }}
            />
            {errors.from && (
              <small className="text-danger">{errors.from}</small>
            )}
          </Col>{" "}
          <Col xl={4} lg={5} md={6} sm={12}>
            <Form.Label>Schedule Time</Form.Label>
            <input
              type="time"
              className={`form-control ${errors.from ? "is-invalid" : ""}`}
              value={schedule_time}
              min={new Date().toISOString().split("T")[0]}
              onChange={(e) => {
                setScheduleTime(e.target.value);
                setErrors((prev) => ({ ...prev, from: "" }));
              }}
            />
            {errors.schedule_time && (
              <small className="text-danger">{errors.schedule_time}</small>
            )}
          </Col>{" "}
          <Col xl={4} lg={5} md={6} sm={12}>
            <Form.Label>Completion Date</Form.Label>
            <input
              type="date"
              className={`form-control ${errors.from ? "is-invalid" : ""}`}
              value={completion_date}
              min={new Date().toISOString().split("T")[0]}
              onChange={(e) => {
                setCompletionDate(e.target.value);
                setErrors((prev) => ({ ...prev, from: "" }));
              }}
            />
            {errors.completion_date && (
              <small className="text-danger">{errors.completion_date}</small>
            )}
          </Col>
        </Row>
      </Modal.Body>

      <Modal.Footer>
        <CancelButton name="Cancel" onClick={onHide} />
        <SaveButton
          name={
            assignLoading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" />
                Submitting...
              </>
            ) : (
              "Submit"
            )
          }
          type="submit"
          disabled={assignLoading}
          handleSubmit={handleAssignEngineer}
        />
      </Modal.Footer>

      <ModalComplaintSave
        message={showModal.message}
        showErrorModal={!!showModal.code}
      />
    </Modal>
  );
};

export default SupportTransfer;
